/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMerchantDefaultBrand} from '../api'

 export const useQueryGetMerchantDefaultBrand = createReactQueryHook('getMerchantDefaultBrand', getMerchantDefaultBrand)
